/**
 * Error text that is safe to show a customer.
 *
 * The API's own refusals ("Files can be up to 1 GB on your plan…", "Each
 * angle must use a different video.") are written for people and pass
 * through unchanged. Messages written for developers - network failures,
 * storage internals, masked server errors, crashes - are replaced with the
 * caller's fallback, which says what happened and what to do next.
 */

const TECHNICAL_MESSAGE = new RegExp(
  [
    'failed to fetch',
    'networkerror',
    'network request failed',
    'network error',
    'load failed',
    'response not successful',
    'status code',
    'unexpected error',
    'internal server error',
    'cannot read prop',
    'is not a function',
    'is not defined',
    'undefined',
    'graphql',
    'variable "\\$',
    'syntax error',
    'could not reach r2',
    'storage request',
    'returned no data',
    'did not return',
    'invalid expectedupdatedat',
    'invalid multicam set id',
  ].join('|'),
  'i'
);

const SIGNED_OUT_MESSAGE = /authentication required|unauthenticated|not authenticated|unauthori[sz]ed|token (has )?expired/i;

export const SIGNED_OUT_COPY = 'Your session has expired. Sign in again, then try once more.';

const messageOf = (error: unknown): string => {
  if (typeof error === 'string') return error.trim();
  const message = (error as { message?: unknown } | null | undefined)?.message;
  return typeof message === 'string' ? message.trim() : '';
};

/** True when the message is developer wording that a customer should never see. */
export const isTechnicalMessage = (message: string): boolean => TECHNICAL_MESSAGE.test(message);

export const friendlyErrorMessage = (error: unknown, fallback: string): string => {
  const message = messageOf(error);
  if (!message) return fallback;
  if (SIGNED_OUT_MESSAGE.test(message)) return SIGNED_OUT_COPY;
  if (isTechnicalMessage(message)) return fallback;
  return message;
};
